import Vue from 'vue'
import Vuex from 'vuex'
import router from '../router/index'


Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    sub: localStorage.getItem("subscription_link") || null,
    token: localStorage.getItem('token') || null,
    user: JSON.parse(localStorage.getItem('user')) || null,
    signIn: {
      signInLoading: false,
      signInDisabled: false,
      signInErrorSnackbar: false,
      signInErrorPayload: null,
      signInSuccessSnackbar: false,
      signInSuccessPayload: null,
    },
    signUp: {
      signUpLoading: false,
      signUpDisabled: false,
      signUpErrorSnackbar: false,
      signUpErrorPayload: null,
    },
    customers: [],
    addedItems: [],
  },
  getters: {
    currentUser: (state) => state.token,
    getUser: (state) => state.user,
    getCustomers: (state) => state.customers,
    getSub: (state) => state.sub,
    getItems: (state) => state.addedItems
  },
  mutations: {
    SET_USER(state, user) {
      state.user = user;
    },
    SET_ITEMS(state, addedItems) {
      state.addedItems = addedItems
    },
    SET_CUSTOMERS(state, customers) {
      state.customers = customers;
    },
    loginUser(state, userData) {
      state.token = userData.token
      state.sub = userData.subscription_link,
        state.user = userData.user
    },
    registerUser(state, userData) {
      state.signUp.signUpLoading = true
      state.signUp.signUpDisabled = true
      state.user = userData.user
    },
    signOut(state) {
      state.user = null
      state.token = null

      localStorage.clear()
    },
    startLoader(state) {
      state.signIn.signInLoading = true
      state.signIn.signInDisabled = true
    },
    stopLoader(state) {
      state.signIn.signInLoading = false
      state.signIn.signInDisabled = false
    },

    signInError(state, error) {
      state.signIn.signInErrorSnackbar = true;
      state.signIn.signInErrorPayload = error;
    },

    signInSuccess(state, payload) {
      state.signIn.signInSuccessSnackbar = true;
      state.signIn.signInSuccessPayload = payload;
    },
  },
  actions: {
    ARRAY_ITEM({ commit }, items) {
      commit('SET_ITEMS', items)
    },
    fetchCustomers({ commit }) {
      fetch("https://receipt.drecsoft.com/api/v1/customer/fetch-customer", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.state.token}`,
        },
      })
        .then((response) => response.json())
        .then((response) => {
          commit('SET_CUSTOMERS', response.data.customer.data)
          console.log(response.data.customer.data);
        })

        .catch((err) => {
          this.loading = false;
          console.log(err);
        })
    },

    SIGN_IN({ commit }, authData) {
      commit('startLoader')
      fetch('https://receipt.drecsoft.com/api/auth/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: authData.email,
          password: authData.password,
        }),
      })
        .then((response) => response.json())
        .then((response) => {
          console.log(">>>>", response)

          if (response?.message === "success") {

            const { accessToken, user, subscription_link, day } = response.data
            commit('loginUser', {
              token: accessToken,
              user: user,
              subscription_link: subscription_link,
              day: day
            })
            localStorage.setItem('subscription_link', response.data.subscription_link)
            if (day === 0) {
              router.push('/subscribe')
              commit('stopLoader');
            } else {

              localStorage.setItem('token', response.data.accessToken)

              localStorage.setItem('user', JSON.stringify(response.data.user))
              router.push('/home');

              commit('stopLoader')
            }





          }
          else {
            commit('stopLoader')
            commit('signInError', response?.short_description)
          }
        }
        )
        .catch((error) => {
          console.log('Error>>>', error)
          commit('signInError', error.message)
          commit('stopLoader')
        })
    },



    SIGN_UP({ commit }, authData) {
      const data = {
        referral: authData.referral,

        email: authData.email,
        phone: authData.phone,
        name: authData.name,
        confirmPassword: authData.confirmPassword,
        password: authData.password,
      }
      commit('startLoader')
      fetch('https://receipt.drecsoft.com/api/auth/register', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
        .then((r) => r.json())
        .then((response) => {
          if (response.status === 'failed') {
            commit('signInError', response)
            commit('stopLoader')
          } else {
            commit('registerUser', { user: response })
            commit('SignUpSuccessful')
            commit('stopLoader')
            router.push("/");
          }
        })
        .catch((error) => {
          console.log('Error>>>>>>>>>>>>>', error)
          commit('signUpError', error)
          commit('stopLoader')
        })
    },
    logout({ commit }) {
      router.push('/')
      commit('signOut')
    },
  },
  modules: {
  }
})
